<template>
    <DsMenu align="end">
        <template #menuTrigger>
            <DsButton
                :disabled="isExportDisabled"
                leading="fa-regular fa-arrow-down-to-line"
                size="sm"
                variant="secondary"
            >
                Export
            </DsButton>
        </template>

        <DsMenuGroup>
            <DsMenuOption
                leading="fa-regular fa-file-spreadsheet"
                @click="$emit('exportCsv')"
            >
                CSV
            </DsMenuOption>
            <DsMenuOption
                leading="fa-regular fa-clone"
                @click="$emit('exportClipboard')"
            >
                Copy
            </DsMenuOption>
        </DsMenuGroup>
    </DsMenu>
</template>

<script setup lang="ts">
import type { FileTableExportEmits } from '@/components/Views/Company/File/file-table.types';
import DsButton from '@ds/button/DsButton.vue';
import DsMenu from '@ds/menu/DsMenu.vue';
import DsMenuGroup from '@ds/menu/DsMenuGroup.vue';
import DsMenuOption from '@ds/menu/DsMenuOption.vue';

defineProps<{ isExportDisabled?: boolean }>();

defineEmits<FileTableExportEmits>();
</script>
